export enum EmailThreadType {
  Enquiry = 'enquiry',
  Lead = 'lead',
  NotLead = 'not_lead',
  AutoNotALead = 'auto_not_a_lead'
}
